import UserModel from './User';
import NotificationsModel from './Notifications';

export default {
  user: UserModel,
  notifications: NotificationsModel,
};
